import { createIcon } from '@chakra-ui/react';

export const Heart = createIcon({
  displayName: 'Heart',
  viewBox: '0 0 24 18',
  path: (
    <path
      id="Heart_-_L"
      data-name="Heart - L"
      d="M23.671,8.713A6.292,6.292,0,0,0,18.406,5.46a6.22,6.22,0,0,0-4.918,1.9,10.225,10.225,0,0,0-.789.945c-.065.088-.137.19-.2.263-.061-.072-.133-.175-.2-.259a9.711,9.711,0,0,0-.789-.949A6.207,6.207,0,0,0,6.6,5.46,6.32,6.32,0,0,0,1.331,8.713a7.142,7.142,0,0,0-.556,5.193A12.016,12.016,0,0,0,4.071,19a34.288,34.288,0,0,0,4.24,3.714l3.482,2.732a1.143,1.143,0,0,0,1.406,0l3.493-2.732A34.116,34.116,0,0,0,20.932,19a11.89,11.89,0,0,0,3.3-5.078A7.171,7.171,0,0,0,23.671,8.713Zm-.526,4.854c-.507,1.6-1.143,2.64-3.048,4.636a33.335,33.335,0,0,1-4.118,3.6L12.5,24.554,9,21.807a33.336,33.336,0,0,1-4.122-3.6,10.916,10.916,0,0,1-3.048-4.636,5.981,5.981,0,0,1,.507-4.339A5.169,5.169,0,0,1,6.6,6.588a5.059,5.059,0,0,1,4.1,1.558c.926.956,1,1.6,1.81,1.6s.88-.632,1.81-1.6a5.028,5.028,0,0,1,4.1-1.558,5.175,5.175,0,0,1,4.255,2.64,5.981,5.981,0,0,1,.484,4.339Z"
      transform="translate(-0.501 -5.46)"
      fill="currentColor"
    />
  ),
});
